import PropTypes from "prop-types";
import { StandardLayout } from "@/react/components/Layout/StandardLayout";
import { RightSidebarContent } from "../RightSidebarContent";
import { useHasSpaceRightSidebar } from "../hooks/useHasSpaceRightSidebar";

export const RightSidebar = () => {
  const hasSpaceRightSidebar = useHasSpaceRightSidebar();

  return (
    <StandardLayout.Right hidden={!hasSpaceRightSidebar}>
      <RightSidebarContent />
    </StandardLayout.Right>
  );
};

RightSidebar.propTypes = {
  space: PropTypes.object,
};
